"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupNode = void 0;
var react_1 = __importDefault(require("react"));
require("./styles/group-node.scss");
/**
 * GroupNode - Custom node component for group/level containers
 * Displays group name at the top, no connection handles
 */
exports.GroupNode = function (_a) {
    var data = _a.data;
    var isInteractive = !!data.groupId && !!data.onGroupClick;
    var handleClick = function () {
        if (data.groupId && data.onGroupClick) {
            data.onGroupClick(data.groupId);
        }
    };
    return (react_1.default.createElement("div", { className: "strategy-group-node" + (isInteractive ? " strategy-group-node--interactive" : ""), onClick: isInteractive ? handleClick : undefined, role: isInteractive ? "button" : undefined, tabIndex: isInteractive ? 0 : undefined, onKeyDown: isInteractive
            ? function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    handleClick();
                }
            }
            : undefined },
        react_1.default.createElement("div", { className: "group-header" }, data.label),
        react_1.default.createElement("div", { className: "group-content" })));
};
